import { Link } from 'react-router-dom'

export default function Hero() {
  return (
    <section className="relative bg-gradient-to-r from-primary-600 to-primary-700 text-white py-20" style={{backgroundImage: 'url(/hero-background.png)', backgroundSize: 'cover', backgroundPosition: '40% 55%', backgroundBlendMode: 'multiply'}}>
      <div className="absolute inset-0 bg-black opacity-30" aria-hidden="true"></div>
      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <h1 className="text-4xl md:text-6xl font-bold mb-6" style={{textShadow: '2px 2px 4px rgba(0,0,0,0.8), -1px -1px 2px rgba(0,0,0,0.8), 1px -1px 2px rgba(0,0,0,0.8), -1px 1px 2px rgba(0,0,0,0.8)'}}>
          Indoctri-NATION 365
        </h1>
        <p className="text-2xl md:text-3xl mb-4 italic font-semibold" style={{textShadow: '2px 2px 4px rgba(0,0,0,0.8), -1px -1px 2px rgba(0,0,0,0.8), 1px -1px 2px rgba(0,0,0,0.8), -1px 1px 2px rgba(0,0,0,0.8)'}}>
          What if the Story You Were Taught About America Was Incomplete by Design?
        </p>
        <p className="text-xl mb-8 opacity-80 max-w-2xl mx-auto font-bold" style={{textShadow: '2px 2px 4px rgba(0,0,0,0.8), -1px -1px 2px rgba(0,0,0,0.8), 1px -1px 2px rgba(0,0,0,0.8), -1px 1px 2px rgba(0,0,0,0.8)'}}>
          How did we get here and what can we do about it?
        </p>
        <Link
          to="/learn"
          className="cta-button"
          aria-label="Uncover hidden truths about American history"
        >
          Uncover Hidden Truths
        </Link>
      </div>
    </section>
  )
}